// 导入React、react-markdown-editor-lite，以及一个你喜欢的Markdown渲染器
import React,{useState,useEffect,forwardRef,useImperativeHandle} from "react";
import MarkdownIt from "markdown-it";
import MdEditor from "react-markdown-editor-lite";
// 导入编辑器的样式
import "react-markdown-editor-lite/lib/index.css";

const MDEditor = forwardRef(({ fileUuid,textContent,height="500px",plugins=["full-screen"] },ref) => {
  const [markdownValue, setMarkdownValue] = useState(textContent);
  const handleEditorChange = ({ html, text })=>{
    setMarkdownValue(text)
  }
  useImperativeHandle(ref, () => ({
    getChildState: () => markdownValue
}));
  useEffect(() => {
    setMarkdownValue(textContent)
}, [textContent]);
  // 初始化Markdown解析器
  const mdParser = new MarkdownIt(/* Markdown-it options */);
  return (
    <MdEditor
      style={{ height }}
      value={markdownValue}
      view={{md:false}}
      renderHTML={(text) => mdParser.render(text)}
      plugins={plugins}
      onChange={handleEditorChange}
    />
  );
});

export default MDEditor;
